import awscf from '../assets/certification/aws_cloud_foundations.png';

const certifications = [
    {
        name: 'AWS Cloud Foundations',
        image: awscf,
        alt: 'AWS Cloud Foundations',
    },
];

export default certifications;